import type { AxiosResponse } from 'axios';
import type { UseDownloaderOptions } from '@trinity/chat-components/containers/QueryDownloader/index.js';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks/useQueryDownloader.js';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { DownloadInsightsSummary } from '@trinity/chat/api/interfaces/projects';

type Params = {
  format: 'pptx' | 'docx';
} & IProjectId;

type Data = DownloadInsightsSummary.Response;

type QueryKey = readonly [string, Params];

type Options = UseDownloaderOptions<Data, AxiosResponse, Data, QueryKey>;

export const useDownloadProjectInsightsReport = (props: Params, options?: Options) => {
  const client = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `get:projects/insights/export`,
      props,
    ],
    queryFn: ({ queryKey }) => {
      const [_, { format, projectId }] = queryKey;
      return client.projects.downloadInsightsSummary({
        format,
        projectId,
      });
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: res.name,
        type: 'blob',
        value: res.file,
      }),
    },
    ...(options ?? {}),
  });
};